import {AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

const validCharacters = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export class EmailValidator extends Validators {
  static validate(control: FormControl): ValidationErrors | null {
    let result = null;

    //if (control.value?.match(validCharacters) === null)
    {
      result = { email: true };
    }

    return result;
  }
}

export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Custom regex or validation logic
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!control.value || emailPattern.test(control.value)) {
      return null; // valid email
    } else {
      return { invalidEmail: { value: control.value } }; // invalid email
    }
  };
}
